import KS from '@/assets/images/5KS.png'
import AG from '@/assets/images/AG.png'
import 白鲨 from '@/assets/images/BS.png'
import BS from '@/assets/images/BS.png'
import EDG from '@/assets/images/EDG.png'
import EP from '@/assets/images/EP.png'
import eStar from '@/assets/images/eStar.png'
import KZ from '@/assets/images/KZ.png'
import Q9 from '@/assets/images/Q9.png'
import LGD from '@/assets/images/R.LGD.png'
import WE from '@/assets/images/WE.png'
import XROCK from '@/assets/images/XROCK.png'
import rng from '@/assets/images/rng.png'
import TBD from '@/assets/images/TBD.svg'
import 火麒麟 from '@/assets/images/火麒麟.png'
import TG from '@/assets/images/TG-Totoro_gaming.png'
import WingsUp from '@/assets/images/WU.png'
import 情久 from '@/assets/images/情久LOGO矢量图.png'
import CLB from '@/assets/images/CLB.2L.png'
import IMP from '@/assets/images/IMP.png'
import PG from '@/assets/images/PG.png'
import PM from '@/assets/images/PM.png'
import TM from '@/assets/images/TM.png'
import 待定 from '@/assets/images/待定.png'

export const images = {
  KS,
  AG,
  白鲨,
  BS,
  EDG,
  EP,
  eStar,
  KZ,
  Q9,
  'R.LGD': LGD,
  LGD: LGD,
  WE,
  XROCK,
  rng,
  TBD,
  火麒麟,
  TG,
  WingsUp,
  情久,
  'CLB.2L': CLB,
  TM,
  PM,
  PG,
  IMP,
  待定
}



// WEBPACK FOOTER //
// ./src/utils/imagesUtil.js